import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles, Grid, CircularProgress, Button, Box } from '@material-ui/core';

import Revisions from './components/Revisions/Revisions';

import styles from './styles';
import withDocumentRevision from 'app/components/Hoc/withDocumentRevision';
const useStyles = makeStyles(styles);

function Documentation(props) {
    const classes = useStyles();

    const { filesStore, generalObsertations, setGeneralObsertations, onSave, onCancel, handleRequestReview } = props;

    const request = useSelector((state) => state.requests.details);

    const canEdit = useMemo(() => {
        return request?.situacao?.boEdicaoPortalInterno;
    }, [request]);

    const requestJsonData = useMemo(() => {
        if (request.jsonSolicitacao) return JSON.parse(request.jsonSolicitacao);
        return {};
    }, [request]);

    const revisionButtonDisabled = useMemo(() => {
        return Boolean(requestJsonData.boVisitante);
    }, [requestJsonData.boVisitante]);

    const [documentsToRevision, setDocumentsToRevision] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            if (filesStore.length > 0) {
                const docs = filesStore[filesStore.length - 1];
                setDocumentsToRevision(docs);
            }
            setLoading(false);
        })();
    }, [filesStore]);

    return (
        <>
            <Grid item xs={12}>
                {loading && (
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                )}
                {!loading && (
                    <Revisions
                        {...props}
                        documentsToRevision={documentsToRevision}
                        setDocumentsToRevision={setDocumentsToRevision}
                        generalObsertations={generalObsertations}
                        setGeneralObsertations={setGeneralObsertations}
                        handleFileChanged={() => {}}
                        canEdit={canEdit}
                    />
                )}
            </Grid>

            <Grid container spacing={3}>
                <div className={classes.actionsContainer}>
                    <Grid item sm={12} md={4}>
                        <Button className={classes.actionsBtns} onClick={() => onCancel()}>
                            <FormattedMessage id="LABELS.COMMONS.BACK" />
                        </Button>
                    </Grid>

                    {canEdit && (
                        <>
                            <Grid item sm={12} md={4}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.actionsBtns}
                                    disableElevation
                                    onClick={() =>
                                        onSave({ fromRequestRevision: false, documentsToRevision: documentsToRevision })
                                    }>
                                    <Box className={classes.colorWhite}>
                                        <FormattedMessage id="LABELS.COMMONS.SAVE" />
                                    </Box>
                                </Button>
                            </Grid>

                            <Grid item sm={12} md={4}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    disabled={revisionButtonDisabled}
                                    className={classes.actionsBtnsRevisionRequest}
                                    onClick={() => handleRequestReview(documentsToRevision)}>
                                    Solicitar ajustes
                                </Button>
                            </Grid>
                        </>
                    )}
                </div>
            </Grid>
        </>
    );
}

export default injectIntl(withDocumentRevision(Documentation));
